"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import * as _Builtin from "./_Builtin/index.js";
import * as _utils from "./utils";
import _styles from "./HpAi26Workflows.module.css";
export function HpAi26Workflows({ as: _Component = _Builtin.Block, headingBlack1 = "Agentic", headingGradient = " workflows ", headingBlack2 = "that run work end to end", headingBlack1Visibility = true, headingBlack2Visibility = true, hideComponent = true, workflowsLogo = "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6988ce8cc1b394830bc12508_monday%20workflows%20logo.svg", sectionSubtitle = "Visually build, automate, and manage complex cross-functional processes with AI.", mainImage = "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6989ad2a057d16cc18c2a792_workflows-image.avif" }) {
    return hideComponent ? /*#__PURE__*/ _jsxs(_Component, {
        className: _utils.cx(_styles, "section_hp-26", "is-workflows"),
        tag: "section",
        children: [
            /*#__PURE__*/ _jsx(_Builtin.Block, {
                className: _utils.cx(_styles, "m_padding-global"),
                tag: "div",
                children: /*#__PURE__*/ _jsxs(_Builtin.Block, {
                    className: _utils.cx(_styles, "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ _jsxs(_Builtin.Block, {
                            className: _utils.cx(_styles, "hp_ai-slider-h-wrapper"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ _jsx(_Builtin.Block, {
                                    className: _utils.cx(_styles, "hp_ai-tagline-wrapper"),
                                    tag: "div",
                                    children: /*#__PURE__*/ _jsx(_Builtin.Image, {
                                        className: _utils.cx(_styles, "hp_ai-logo"),
                                        width: "auto",
                                        height: "auto",
                                        loading: "lazy",
                                        alt: "",
                                        src: workflowsLogo
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(_Builtin.Block, {
                                    className: _utils.cx(_styles, "heading_wrapper-26", "is-workflows"),
                                    tag: "div",
                                    children: [
                                        headingBlack1Visibility ? /*#__PURE__*/ _jsx(_Builtin.Heading, {
                                            className: _utils.cx(_styles, "hp_section-title", "is-monday-workflows", "text-style-inline"),
                                            tag: "h2",
                                            children: headingBlack1
                                        }) : null,
                                        /*#__PURE__*/ _jsx(_Builtin.Heading, {
                                            className: _utils.cx(_styles, "hp_section-title", "is-monday-workflows", "hp_h-gradient-workflows", "text-style-inline"),
                                            tag: "h2",
                                            children: headingGradient
                                        }),
                                        headingBlack2Visibility ? /*#__PURE__*/ _jsx(_Builtin.Heading, {
                                            className: _utils.cx(_styles, "hp_section-title", "is-monday-workflows", "text-style-inline"),
                                            tag: "h2",
                                            children: headingBlack2
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(_Builtin.Block, {
                                    className: _utils.cx(_styles, "hide-element"),
                                    tag: "div",
                                    children: /*#__PURE__*/ _jsxs(_Builtin.Heading, {
                                        className: _utils.cx(_styles, "hp_section-title", "is-monday-workflows"),
                                        tag: "h2",
                                        children: [
                                            "Agentic ",
                                            /*#__PURE__*/ _jsx(_Builtin.Span, {
                                                className: _utils.cx(_styles, "hp_h-gradient-workflows"),
                                                children: "workflows"
                                            }),
                                            " that run work end to end"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(_Builtin.Block, {
                                    className: _utils.cx(_styles, "hp_subtitle-wrapper"),
                                    tag: "div",
                                    children: /*#__PURE__*/ _jsx(_Builtin.Block, {
                                        className: _utils.cx(_styles, "hp_subtitle", "is-workflows"),
                                        tag: "div",
                                        children: sectionSubtitle
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(_Builtin.Block, {
                            className: _utils.cx(_styles, "hp-ai_workflows-image-wrapper"),
                            tag: "div",
                            children: /*#__PURE__*/ _jsx(_Builtin.Image, {
                                className: _utils.cx(_styles, "hp-ai_workflows-image"),
                                width: "auto",
                                height: "auto",
                                loading: "lazy",
                                alt: "",
                                src: mainImage
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(_Builtin.HtmlEmbed, {
                content: "",
                value: "%3Cstyle%3E%0A%5Bclass*%3D%22hp_h-gradient-workflows%22%5D%20%7B%20%20%0A%20%20background-image%3A%20linear-gradient(45deg%2C%20rgb(58%2C%20201%2C%20255)%2C%20rgb(122%2C%20127%2C%20240))%3B%0A%20%20background-clip%3A%20text%3B%0A%20%20-webkit-text-fill-color%3A%20transparent%3B%0A%7D%0A%3C%2Fstyle%3E"
            })
        ]
    }) : null;
}
